__webpack_require__.p = "/etc.clientlibs/clientlibs/vwa-ngw18/ngw18-frontend/apps/resources";